module.exports = __webpack_public_path__ + "3c9a5acd2e1f1705ab9314e781177fdb.png";